/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {_MAT_INK_BAR_POSITIONER_FACTORY as Éµangular_material_src_material_tabs_tabs_a} from './ink-bar';
export {MatPaginatedTabHeader as Éµangular_material_src_material_tabs_tabs_b} from './paginated-tab-header';